import { Link } from "@design-system/Link/Link";
import { SettingsPanel } from "@design-system/SettingsPanel/SettingsPanel.lib";
import { Switch } from "@design-system/Switch/Switch";

const UI_ONLY_HINT = "UI only. The backend ignores this override";
const FROM_FIRM_HINT = "Set for the firm";

const buildHint = ({
    isUiOnly,
    isFromFirm,
}: {
    isUiOnly: boolean;
    isFromFirm: boolean;
}): string => {
    const hints: string[] = [];
    if (isFromFirm) {
        hints.push(FROM_FIRM_HINT);
    }
    if (isUiOnly) {
        hints.push(UI_ONLY_HINT);
    }
    return hints.join(". ");
};

export const DemoFlagRow = ({
    flag,
    checked,
    isUiOnly,
    isFromFirm = false,
    onCheckedChange,
    onReset,
}: {
    flag: string;
    checked: boolean;
    isUiOnly: boolean;
    isFromFirm?: boolean;
    onCheckedChange: (checked: boolean) => void;
    onReset?: () => void;
}) => (
    <SettingsPanel.Row
        label={flag}
        labelId={`demo-flag-${flag}`}
        hint={buildHint({ isUiOnly, isFromFirm })}
    >
        {onReset && (
            <Link size="xs" onClick={onReset}>
                Reset
            </Link>
        )}
        <Switch
            size="sm"
            aria-labelledby={`demo-flag-${flag}`}
            checked={checked}
            onCheckedChange={onCheckedChange}
        />
    </SettingsPanel.Row>
);
